import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Search, User, Menu, X } from 'lucide-react';
import { navLinks } from '../mock';

function DesktopNav() {
  return (
    <nav style={{ display: 'flex', gap: 26, alignItems: 'center', flex: 1 }} className="nav-desktop">
      {navLinks.map((l) => (
        <NavLink
          key={l.key}
          to={l.path}
          end={l.path === '/'}
          className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}
          style={({ isActive }) => ({
            textDecoration: 'none',
            color: isActive ? '#17b4b4' : '#1a1a1a',
            fontWeight: isActive ? 700 : 600,
            fontSize: 15,
            transition: 'color 150ms ease',
          })}
        >
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
}

function MobileMenu({ onClose }) {
  return (
    <div style={{ background: '#fff', padding: '16px 24px', display: 'flex', flexDirection: 'column', gap: 12, borderTop: '1px solid #eee' }}>
      {navLinks.map((l) => (
        <NavLink
          key={l.key}
          to={l.path}
          end={l.path === '/'}
          onClick={onClose}
          style={({ isActive }) => ({
            color: isActive ? '#17b4b4' : '#1a1a1a',
            fontWeight: 600,
            textDecoration: 'none',
            fontSize: 15,
          })}
        >
          {l.label}
        </NavLink>
      ))}
    </div>
  );
}

function SearchBox({ query, setQuery, onSubmit }) {
  return (
    <form onSubmit={onSubmit} style={{ position: 'relative' }}>
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder=""
        style={{
          padding: '8px 40px 8px 16px',
          border: '1.5px solid #f6a06a',
          borderRadius: 999,
          outline: 'none',
          background: '#ffffff',
          width: 200,
          fontSize: 14,
          color: '#1a1a1a',
          transition: 'box-shadow 200ms ease, border-color 200ms ease',
        }}
        onFocus={(e) => { e.target.style.boxShadow = '0 0 0 3px rgba(246,160,106,0.25)'; }}
        onBlur={(e) => { e.target.style.boxShadow = 'none'; }}
      />
      <button type="submit" aria-label="Axtar" style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', cursor: 'pointer', color: '#f97316' }}>
        <Search size={16} />
      </button>
    </form>
  );
}

export default function Navbar() {
  const [query, setQuery] = useState('');
  const [mobile, setMobile] = useState(false);
  const navigate = useNavigate();

  const onSearch = (e) => {
    e.preventDefault();
    if (!query.trim()) return;
    navigate('/bloq');
  };

  return (
    <header style={{ position: 'sticky', top: 0, zIndex: 30, background: '#ffffff', borderBottom: '1px solid transparent' }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', gap: 24, padding: '18px 24px' }}>
        <DesktopNav />
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }} className="nav-right">
          <button aria-label="Profil" style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: '#1a1a1a' }}>
            <User size={22} />
          </button>
          <SearchBox query={query} setQuery={setQuery} onSubmit={onSearch} />
          <button className="nav-mobile-btn" aria-label="Menu" onClick={() => setMobile(!mobile)} style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: '#1a1a1a', display: 'none' }}>
            {mobile ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      <div style={{ height: 2, background: 'linear-gradient(90deg, transparent 0%, #f6a06a 15%, #f6a06a 85%, transparent 100%)' }} />
      {mobile && <MobileMenu onClose={() => setMobile(false)} />}
      <style>{`
        @media (max-width: 900px) {
          .nav-desktop { display: none !important; }
          .nav-mobile-btn { display: inline-flex !important; }
        }
        .nav-link:hover { color: #17b4b4 !important; }
      `}</style>
    </header>
  );
}
